// extracted by mini-css-extract-plugin
export default {"loaderContainer":"App_loaderContainer__7Zo9Y","appContainer":"App_appContainer__Q73Qs"};